// extracted by mini-css-extract-plugin
module.exports = {"calendarContainer":"ClockData_calendarContainer__1uYgd","calendarButtons":"ClockData_calendarButtons__3Zx_C"};